/* eslint-disable react/prop-types */
import { DARK } from '@core/constants/theme';
import { styled } from '@ublend-npm/aulaui-core';
import React from 'react';

const DateContainer = styled('span')(({ theme }) => ({
  color:
    theme.palette.mode === DARK
      ? 'rgba(255, 255, 255, 0.7)'
      : 'rgba(0, 0, 0, 0.6)',
  fontFamily: 'Roboto, sans-serif',
}));

const formatTime = (date) => {
  const dateObj = new Date(date);
  return dateObj
    .toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    .toLowerCase();
};

export default React.memo(({ date }) => (
  <DateContainer title={new Date(date).toLocaleString('en-GB')}>
    {formatTime(date)}
  </DateContainer>
));
